import { render, staticRenderFns } from "./n-loader.html?vue&type=template&id=1cfa240b&scoped=true&"
import script from "./n-loader.js?vue&type=script&lang=js&"
export * from "./n-loader.js?vue&type=script&lang=js&"
import style0 from "./n-loader.scss?vue&type=style&index=0&id=1cfa240b&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cfa240b",
  null
  
)

export default component.exports